// @flow

// Vendors
import React, { useState, useEffect } from 'react';

// Components
import { UserList } from '..';

// Requests
import { updateUserStatusRequest, getUsersRequest } from '../../requests';

const ManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [isSubmitting, setSubmitting] = useState(false);

  useEffect(() => {
    getUsersRequest().then(({ data }) => {
      setUsers(data);
    });
  }, []);

  const adminUsers = users.filter(
    ({ organization_role }) => organization_role === 'admin'
  );

  const activeUsers = users.filter(
    ({ organization_role }) => organization_role === 'member'
  );

  const inactiveUsers = users.filter(
    ({ organization_role }) => organization_role === 'inactive'
  );

  const pendingUsers = users.filter(
    ({ organization_role }) => organization_role === 'pending'
  );

  const handleUpdateStatusClick = (id, status) => {
    if (!id || !status) return false;

    updateUserStatusRequest({ id, status })
      .then(({ data }) => {
        setSubmitting(false);
        const { status } = data;

        const userIndex = users.findIndex(user => user.id === id);

        if (status !== 'rejected') {
          users[userIndex].organization_role = status;
        } else {
          users.splice(userIndex, 1);
        }

        return setUsers([...users]);
      })
      .catch(() => {
        setSubmitting(false);
      });
  };

  return (
    <div className="account-form card">
      {(adminUsers.length > 0 || activeUsers.length > 0) && (
        <div className="card__section">
          <h3>Active Users</h3>
          <UserList
            className="u--border-width-bottom-0 u--margin-bottom-0"
            users={adminUsers}
            type="admin"
            handleUpdateStatusClick={handleUpdateStatusClick}
            isSubmitting={isSubmitting}
          />
          <UserList
            users={activeUsers}
            type="active"
            handleUpdateStatusClick={handleUpdateStatusClick}
            isSubmitting={isSubmitting}
          />
          <p>
            <a href="/resource-center/users/add" className="btn btn--primary">
              Add New User
            </a>
          </p>
        </div>
      )}

      {pendingUsers.length > 0 && (
        <div className="card__section">
          <h3>Pending Users</h3>
          <UserList
            users={pendingUsers}
            type="pending"
            handleUpdateStatusClick={handleUpdateStatusClick}
            isSubmitting={isSubmitting}
          />
        </div>
      )}

      {inactiveUsers.length > 0 && (
        <div className="card__section">
          <h3>Deactivated Users</h3>
          <UserList
            users={inactiveUsers}
            type="inactive"
            handleUpdateStatusClick={handleUpdateStatusClick}
            isSubmitting={isSubmitting}
          />
        </div>
      )}
    </div>
  );
};

export default ManageUsers;
